import type { TenderStatus } from '@/api/sourcing/sourcing.types';

export const STATUS_LABEL: Record<TenderStatus, string> = {
  DRAFT: 'Entwurf',
  PUBLISHED: 'Veröffentlicht',
  CLOSED: 'Geschlossen',
  AWARDED: 'Vergeben',
  CANCELLED: 'Storniert',
};

/** DsPill status class for a tender status (empty = neutral pill). */
export function statusPillClass(status: TenderStatus): string {
  switch (status) {
    case 'AWARDED':
      return 'pos';
    case 'CLOSED':
      return 'warn';
    case 'CANCELLED':
      return 'neg';
    default:
      return 'muted';
  }
}

export function fmtDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}.${String(
    d.getMonth() + 1,
  ).padStart(2, '0')}.${d.getFullYear()}`;
}

export function fmtDateTime(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${fmtDate(iso)} ${String(d.getHours()).padStart(2, '0')}:${String(
    d.getMinutes(),
  ).padStart(2, '0')}`;
}

export function fmtEUR(value: number): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
}

/** ISO string → value for an <input type="datetime-local">. */
export function toDateTimeLocal(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate(),
  )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** <input type="datetime-local"> value → ISO string. */
export function fromDateTimeLocal(value: string): string | null {
  if (!value) return null;
  return new Date(value).toISOString();
}
